var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumpadCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 1.342L10.658.167 6 4.825 1.342.167.167 1.342 4.825 6 .167 10.658l1.175 1.175L6 7.175l4.658 4.658 1.175-1.175L7.175 6l4.658-4.658z",
    fill: "#fff"
  })));
}
export default SvgNumpadCloseButton;